module.exports = __webpack_public_path__ + "f8fba525ed8f7fe99b8a9b906169d0b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/file.svg
// module id = 751
// module chunks = 0